import * as Yup from 'yup';
import validation from 'modules/v2/common/validationSchema';

const validationSchema = Yup.object().shape({
  name: validation.campaignName,
  allSegments: validation.campaignAllSegments,
  segments: validation.campaignSegments,
  startDate: validation.campaignStartDate,
});

export default validationSchema;
